import { render } from "./ChatWidgetList.vue?vue&type=template&id=12981980&scoped=true"
import script from "./ChatWidgetList.vue?vue&type=script&lang=js"
export * from "./ChatWidgetList.vue?vue&type=script&lang=js"

import "./ChatWidgetList.vue?vue&type=style&index=0&id=12981980&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12981980"]])

export default __exports__